import { render } from "./DeletePopup.vue?vue&type=template&id=0132e7c8&ts=true"
import script from "./DeletePopup.vue?vue&type=script&lang=ts"
export * from "./DeletePopup.vue?vue&type=script&lang=ts"

import "./DeletePopup.vue?vue&type=style&index=0&id=0132e7c8&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__